import React from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import {theme} from "../../../../shared/theme";
import Typography from "@material-ui/core/Typography";
import {colors} from "../../../../shared/colors";

const useStyles = makeStyles({
    caption: {
        fontWeight: 500,
        color: colors.font.light
    },
    container: {
        backgroundColor: "#FFF3D4",
        padding: theme.spacing(2)
    }
});

const RichiediDelleFattureNotification = (props) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            <Grid container className={classes.container} alignItems={"center"}>
                <Grid item xs={12} sm={2} md={2}>
                    <Typography variant={"caption"} className={classes.caption}>{props.title}</Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={10}>
                    <Typography variant={"body1"}>{props.text}</Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default RichiediDelleFattureNotification;
